import axios from 'axios';
import {
  ADD_MAPPED_FIELDS_TO_PROFILE,
  ADD_RULES_IDS_TO_PROFILE,
  BLUR_PROFILE_FIELD_SUCCESS, FETCH_PROFILE_COMPLETE, FETCH_PROFILE_ERROR,
  FETCH_PROFILE_LIST_SUCCESS, FETCHING_PROFILE,
  RESET_PROFILE,
  SET_POSITION_IDENTIFIER_SUCCESS,
  SET_PROFILE_FOR_EDITION,
  UPDATE_PROFILE_FIELD_SUCCESS,
  UPDATE_TARGET_FIELDS_ID,
  FETCHING_PROFILES_LIST,
  SET_PROFILE_EDITION_MODE, 
  RESET_PROFILE_EDITION_MODE
} from './ProfilesConstants';
import { fetchTargetById } from '../targetFields/TargetFieldsActions';

const fetchProfileListSuccess = profilesList => ({ type: FETCH_PROFILE_LIST_SUCCESS, profilesList });
const fetchingProfilesList = () => ({ type: FETCHING_PROFILES_LIST});
const updateProfileFieldSuccess = (fieldName, fieldValue) => ({ type: UPDATE_PROFILE_FIELD_SUCCESS, fieldName, fieldValue});
const blurProfileFieldSuccess = () => ({ type: BLUR_PROFILE_FIELD_SUCCESS });
const resetProfile = () => ({ type: RESET_PROFILE });
const setPositionIdentifierSuccess = position => ({ type: SET_POSITION_IDENTIFIER_SUCCESS, position });
const addMappedFieldsToProfileSuccess = mappedFields => ({ type: ADD_MAPPED_FIELDS_TO_PROFILE ,mappedFields });
const addRuleIdsToProfileSuccess = ruleIds => ({ type: ADD_RULES_IDS_TO_PROFILE, ruleIds });
const updateTargetFieldsID = targetId => ({ type: UPDATE_TARGET_FIELDS_ID, targetId });
const setProfileForEdition = (profile, mappedFields) => ({ type: SET_PROFILE_FOR_EDITION, profile, mappedFields });
const fetchingProfile = () => ({ type: FETCHING_PROFILE });
const fetchProfileComplete = profile => ({ type: FETCH_PROFILE_COMPLETE, profile });
const fetchProfileError = () => ({ type: FETCH_PROFILE_ERROR });
const setProfileEditionMode = () => ({ type: SET_PROFILE_EDITION_MODE });
const resetProfileEditionMode = () => ({ type: RESET_PROFILE_EDITION_MODE });

const path = 'utm/v1/profiles';

const fetchProfileList = () => dispatch => {
  dispatch(fetchingProfilesList());
  axios.get(path)
    .then(profilesList => {
      if (profilesList.data.error) throw profilesList.data.error;
      dispatch(fetchProfileListSuccess(profilesList.data.data));
    })
    .catch(error => { throw error; });
};

//TODO: check if we can use this structure from redux directly so we don't convert
const convertProfileToNestedStructure = (
  {
    id,
    name,
    description,
    dateFormat,
    thousandsSeparator,
    decimalSeparator,
    columnDelimiter, 
    transformedFileType, 
    maps, 
    ruleSets, 
    stripCurrencySymbols, 
    targetId, 
    isAudit, 
    transactionType, 
    calculationType 
  }, 
  sourceFields, 
  translationTables,
  unconfirmedTranslationTables
) => ({
  id,
  targetId,
  name,
  description,
  ruleSets,
  map: {
    sourceFields,
    dateFormat,
    thousandsSeparator,
    decimalSeparator,
    separator: columnDelimiter,
    //TODO: Remove hardcoded
    allowCurrencySymbols: false,
    transformedFileType,
    stripCurrencySymbols,
    maps,
    translationsId: [...translationTables.map( tTable => tTable.id ), ...unconfirmedTranslationTables.map( tTable => tTable.id )]
  },
  isAudit,
  transactionType,
  calculationType
});

const addProfile = (profile, mappingInfo, history) => (dispatch, getState) => {
  axios.post(path, convertProfileToNestedStructure(profile, mappingInfo, getState().profileTranslationTables.translationTables, getState().profileTranslationTables.unconfirmedTranslationTables))
    .then(updateResponse => {
      if(updateResponse.data.status === 200) {
        history.push('/import-data');
      }
      else {
        console.log('Error while updating profile');
      }
    })
    .catch(error => { throw error; });
};

const updateProfileField = (fieldName, fieldValue) => dispatch => dispatch(updateProfileFieldSuccess(fieldName, fieldValue));

const blurProfileField = () => dispatch => dispatch(blurProfileFieldSuccess());

const setPositionIdentifier = position => dispatch => dispatch(setPositionIdentifierSuccess(position));

const addMappedFieldsToProfile = mappedFields => dispatch => dispatch(addMappedFieldsToProfileSuccess(mappedFields));

const addRuleIdsToProfile = ruleIds => dispatch => dispatch(addRuleIdsToProfileSuccess(ruleIds));

const deleteProfile = id => dispatch => {
  dispatch(fetchingProfilesList());
  axios.delete(`${path}/${id}`)
    .then(() => {
      dispatch(fetchProfileList());
    })
    .catch(error => { throw error; } );
};

const updateProfile = (profile, mappingInfo, history) => (dispatch, getState) => {
  axios.put(path, convertProfileToNestedStructure(profile, mappingInfo, getState().profileTranslationTables.translationTables, getState().profileTranslationTables.unconfirmedTranslationTables))
    .then(updateResponse => {
      if(updateResponse.data.status === 200) {
        history.push('/import-data');
      }
      else {
        console.log('Error while updating profile');
      }
    })
    .catch(error => { throw error; });
};

const fetchProfileById = id => dispatch => {
  dispatch(fetchingProfile());
  axios.get(`${path}/${id}`)
    .then(profileResponse => {
      const mappedFields = [];
      const profile = profileResponse.data.data;
      profile.map.maps.forEach(subGroup => subGroup.fields.forEach(({ sourceField, targetField}) => mappedFields.push({
        activeDivision: subGroup.posIdentifier -1,
        subGroup: subGroup.identifier,
        sourceField,
        targetField
      })));
      dispatch(fetchTargetById(profile.targetId));
      dispatch(setProfileForEdition(profile, mappedFields));
      dispatch(fetchProfileComplete(profile));
    })
    .catch(error => {
      fetchProfileError();
      throw error;
    });
};

export {
  fetchProfileList,
  addProfile,
  updateProfileField,
  resetProfile,
  blurProfileField,
  setPositionIdentifier,
  addMappedFieldsToProfile,
  addRuleIdsToProfile,
  updateTargetFieldsID,
  deleteProfile,
  updateProfile,
  fetchProfileById,
  setProfileEditionMode,
  resetProfileEditionMode
};



// WEBPACK FOOTER //
// ./src/redux/profiles/ProfilesActions.js